/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import { homeActions } from "actions";
import { Helmet } from "react-helmet";
import { Typography, Box, Grid, useMediaQuery, useTheme } from "@mui/material";
//import man from "assets/images/man.png";
import FooterView from "components/FooterView";
import mobileTopArc from "assets/images/mobile-top-curve.svg";
import worksTop from "assets/images/works-top.png";
import { AppleStoreButton, PlayStoreButton } from "components/PlayStoreButton";

const HowItWorks = (props) => {
  const { setValue, updateGTMDataLayer, gtmInfo, organizationInfo } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("(max-width:1000px)");
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const matches500MaxWidth = useMediaQuery("(max-width:500px)");
   
  const isShowBackgroundAssets =
    organizationInfo?.organizationOptionJson?.showBackgroundAssetsFlag?.toUpperCase() ===
    "Y";

  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };

  const isShowAppStoreBand =
    organizationInfo?.organizationOptionJson?.showAppStoreBand?.toLowerCase() ===
    "y";

  useEffect(() => {
    setValue(2);
    document.getElementById("appcontent").scroll(0, 0);
    updateGTMDataLayer({
      event: "Nav_how_it_works",
      page: "Global",
      screen: "How it works",
      screen_title: "Global",
    });
    return () => {
      updateGTMDataLayer({
        screen_referrer: "how it works",
        event: "Nav_how_it_works",
        page: "Global",
        screen: "How it works",
        screen_title: "Global",
      });
    };
  }, []);

  useEffect(() => {
    window.dataLayer.push({
      ...tagManagerArgs.dataLayer,
    });
  }, [gtmInfo]);

  return (
    <Box>
      {isShowBackgroundAssets && (
        <>
          <Box sx={{ display: matches ? "block" : "none" }}>
            <img
              src={mobileTopArc}
              alt="mabile-arc"
              className="left-mobile-arc"
              style={{ transform: "rotate(180deg)" }}
            />
          </Box>

          <Box
            sx={{
              display: matches ? "none" : "block",
              position: "absolute",
              top: 0,
              right: 0,
              left: 0,
              zIndex: -1,
            }}
          >
            <img
              src={worksTop}
              alt="top"
              style={{ width: "100%", height: "280px" }}
            />
          </Box>
        </>
      )}
      <Grid container direction="column" sx={{ position: "relative" }}>
        <Helmet>
          <title>
            How Cuverd Works for Prescription Savings and Discounts |{" "}
            {organizationInfo?.app?.appCode === "CVD"
              ? "Cuverd® Partner"
              : "Cuverd®"}
          </title>
          <meta
            name="Description"
            content="How Cuverd works to give you discounts and savings on your prescription medications."
          />
          <meta
            property="og:title"
            content="How Cuverd Works for Prescription Savings and Discounts | Cuverd®"
          />
          <meta
            property="og:description"
            content="How Cuverd works to give you discounts and savings on your prescription medications."
          />
          <meta
            property="og:image"
            content="assets/images/cuverd-logo-header.png"
          />
          <link
            rel="alternate"
            href="https://www.cuverd.com/how-cuverd-works"
            hrefLang="en-us"
          />
          <link
            rel="canonical"
            href="https://www.cuverd.com/how-cuverd-works"
          />
        </Helmet>

        {isShowBackgroundAssets && (
          <Box
            className="work-bottom"
            sx={{ display: matches ? "none" : "block" }}
          ></Box>
        )}
        <Grid
          item
          container
          ml={isSmallScreen ? undefined : "14rem"}
          mt={isSmallScreen ? "20px" : "56px"}
          mb={isSmallScreen ? "20px" : undefined}
          sx={{ zIndex: 2, marginBottom: { xs: "0", sm: "0", md: "100px" } }}
        >
          <Typography
            variant="h1LatoBlack"
            sx={{
              fontSize: matches ? "24px" : undefined,
              paddingLeft: matches ? "24px" : undefined,
            }}
          >
            How It Works
          </Typography>
        </Grid>
        <Grid
          item
          container
          direction="row"
          sx={{ padding: matches ? "24px" : undefined }}
        >
          <Grid
            item
            sm={4}
            xs={12}
            sx={{
              display: { xs: "none", sm: "none", md: "block", xl: "block" },
            }}
          >
            <Box
              sx={{
                height: "25%",
                width: "90%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "5%",
              }}
            >
              <div className="player-wrapper">
                <ReactPlayer
                  url="https://news.cuverd.com/What Is Cuverd.mp4"
                  className="react-player"
                  playing
                  width="100%"
                  height="100%"
                  controls={true}
                  pip={true}
                  volume={true}
                  muted={true}
                />
              </div>
            </Box>
            <br />
            <Box
              sx={{
                height: "25%",
                width: "90%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "5%",
              }}
            >
              <div className="player-wrapper">
                <ReactPlayer
                  url="https://news.cuverd.com/How It Works.mp4"
                  className="react-player"
                  playing
                  width="100%"
                  height="100%"
                  controls={true}
                  pip={true}
                  volume={true}
                  muted={true}
                />
              </div>
            </Box>
          </Grid>
          <Grid
            item
            container
            direction="column"
            sm={8}
            xs={12}
            alignItems={isSmallScreen ? "left" : undefined}
          >
            <Typography variant="h2LatoSemiBold">
              Cuverd® is a technology that
            </Typography>
            <Typography
              variant="latoSemiBoldItalic"
              sx={{
                fontSize: { xs: "40px", sm: "40px", md: "70px" },
                lineHeight: { xs: "44px", sm: "44px", md: "76px" },
              }}
            >
              SEARCHES
            </Typography>
            <Typography
              variant="latoSemiBoldItalic"
              sx={{
                fontSize: { xs: "40px", sm: "40px", md: "70px" },
                lineHeight: { xs: "44px", sm: "44px", md: "76px" },
              }}
            >
              SMARTER
            </Typography>
            <Typography variant="h2LatoSemiBold" sx={{ lineHeight: "26px" }}>
              than any other prescription savings service.
            </Typography>
            <br />
            <Box sx={{ maxWidth: matches500MaxWidth ? undefined : "500px" }}>
              <Typography
                variant="h2LatoSemiBold"
                sx={{
                  lineHeight: "26px",
                  fontSize: matches ? "20px" : "20px",
                }}
                mt={5}
                dangerouslySetInnerHTML={{
                  __html:
                    organizationInfo?.organizationOptionJson?.appDescription,
                }}
              ></Typography>
              <br />
              <br />
              <Typography
                variant="h2LatoSemiBold"
                sx={{ lineHeight: "26px" }}
                mt={5}
              >
                Cuverd{" "}
                {organizationInfo?.app?.appCode.toLowerCase() !== "wgn" &&
                  "is accepted at over 70,000 pharmacies nationwide and "}
                is easy to use: all you have to do is show your pharmacist your
                coupon on the Cuverd website when you pick up your prescription.
              </Typography>
              <br />
              <br />
              <Typography
                variant="h2LatoSemiBold"
                sx={{ lineHeight: "26px" }}
                mt={5}
              >
                If your medication isn't available at a lower price, Cuverd can
                show you alternative options to discuss with your prescriber.
              </Typography>
            </Box>
            {matches ? (
              <Box
                sx={{
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    textAlign: "center",
                    paddingTop: "10px",
                  }}
                >
                  <Typography
                    variant="h1LatoBlack"
                    mt={isSmallScreen ? 5 : 20}
                    mb={5}
                    sx={{
                      textTransform: "uppercase",
                      fontSize: "20px",
                    }}
                  >
                    No Matter your situation, we've got you cuverd.
                  </Typography>
                </Box>
                <Box
                  sx={{ width: "100%", height: "540px", textAlign: "center" }}
                >
                  <Box
                    sx={{
                      height: "45%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop: "5%",
                      paddingBottom: "5%",
                    }}
                  >
                    <div className="player-wrapper">
                      <ReactPlayer
                        url="https://news.cuverd.com/What Is Cuverd.mp4"
                        className="react-player"
                        playing
                        width="100%"
                        height="100%"
                        controls={true}
                        pip={true}
                        volume={true}
                        muted={true}
                      />
                    </div>
                  </Box>
                  <br />
                  <Box
                    sx={{
                      height: "45%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop: "5%",
                    }}
                  >
                    <div className="player-wrapper">
                      <ReactPlayer
                        url="https://news.cuverd.com/How It Works.mp4"
                        className="react-player"
                        playing
                        width="100%"
                        height="100%"
                        controls={true}
                        pip={true}
                        volume={true}
                        muted={true}
                      />
                    </div>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box mt={isSmallScreen ? 5 : "119px"} sx={{ height: "220px" }}>
                <Typography
                  variant="h1LatoBlack"
                  sx={{ textTransform: "uppercase" }}
                >
                  No Matter&nbsp;
                  <br />
                  your situation,&nbsp;
                  <br />
                  we've got you&nbsp;
                  <br />
                  cuverd.&nbsp;
                </Typography>
              </Box>
            )}
            {isShowAppStoreBand ? (
              <>
                <Box sx={{ textAlign: matches ? "center" : undefined }}>
                  <Typography
                    variant="h3LatoBlack"
                    sx={{ textTransform: "uppercase", letterSpacing: "0.84px" }}
                  >
                    Download The App
                  </Typography>
                </Box>
                <Box
                  mt={"10px"}
                  mb={2}
                  sx={{
                    display: "flex",
                    flexDirection: matches ? "column" : "row",
                    alignItems: matches ? "center" : undefined,
                  }}
                >
                  <Box
                    ml={matches ? undefined : -1.3}
                    mr={matches ? undefined : 1}
                    mb={matches ? 2 : undefined}
                    sx={{ zIndex: 1, width: matches ? "60vw" : undefined }}
                  >
                    <AppleStoreButton />
                  </Box>
                  <Box sx={{ width: matches ? "60vw" : undefined }}>
                    <PlayStoreButton />
                  </Box>
                </Box>
              </>
            ) : null}
          </Grid>
        </Grid>
        <Grid item container>
          <FooterView />
        </Grid>
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    gtmInfo: state.gtmInfo.data,
    organizationInfo: state.organizationInfo.data,
  };
};

const mapDispatchToProps = {
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
};

export default connect(mapStateToProps, mapDispatchToProps)(HowItWorks);
